import { css } from "@linaria/core";

import { TABLET_BREAKPOINT_PX } from "../../../../styles/constants";
import { breakpointDownMixin } from "../../../../styles/mixins/breakpoints";
import { verticalMarginMixin } from "../../../../styles/mixins/collapsableMargin";
import { colorPropMixin } from "../../../../styles/mixins/colorProp";
import { listReset } from "../../../../styles/resets";
import { colorProps, headerPaddingProp } from "../../../../styles/variables";
import { fadeInTransitionDurationMs } from "../../../styles/App";
import { footerHeightProp } from "../../Footer/styles/Footer";
import { headerHeightProp } from "../../Header/styles/Header";

export const subNavigationWidthProp = "--sub-navigation--width";

export const asideCls = css`
  position: absolute;
  top: var(${headerHeightProp});
  left: 0;
  bottom: var(${footerHeightProp});

  box-sizing: border-box;
  width: var(${subNavigationWidthProp});

  border-right: 1px solid ${colorPropMixin(colorProps.grey_100)};

  :global(:root) {
    ${subNavigationWidthProp}: 30rem;
  }

  &.enter {
    opacity: 0.001;

    &-active {
      opacity: 1;
      transition: opacity ${fadeInTransitionDurationMs}ms linear;
    }
  }

  &.exit {
    display: none;
  }

  /**
   * hide the SubNavigation once there is no longer room for it without causing
   * content to be squished together
   */
  @media screen and (${breakpointDownMixin(TABLET_BREAKPOINT_PX)}) {
    display: none;

    :global(:root) {
      ${subNavigationWidthProp}: 0;
    }
  }
`;

export const navCls = css`
  position: absolute;
  inset: 0;

  &.enter {
    opacity: 0.001;

    &-active {
      opacity: 1;
      transition: opacity ${fadeInTransitionDurationMs}ms linear;
    }
  }

  &.exit {
    display: none;
  }
`;

export const skeletonCls = css`
  ${listReset};

  padding: 5rem var(${headerPaddingProp});
`;

export const skeletonLineCls = css`
  ${verticalMarginMixin("2rem")};

  height: 2rem;
  width: 100%;

  background: ${colorPropMixin(colorProps.grey_100)};
`;
